module.exports = __webpack_public_path__ + "static/media/hall-P7-2026.da35b9cd.svg";